import { SagaIterator } from 'redux-saga';
import { put, call, takeLatest, StrictEffect } from 'redux-saga/effects';
import {
  fetchAdminIssues,
  fetchAdminIssuesError,
  fetchAdminIssuesSearch,
  fetchAdminIssuesSuccess,
  putAdminIssuesStatus,
  putAdminIssuesArchiveSaga,
  fetchAdminIssuesArchived,
  fetchAdminIssuesArchivedSuccess,
} from './index';
import { apiInstance } from 'src/services/interceptor';
import { PayloadAction } from '@reduxjs/toolkit';
import { fetchMyReports } from '../myReports';

interface PayloadProps {
  siteId: string;
  reportNumber?: string | null;
  status?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  nextToken?: string | null;
  params?: {
    reportNumber?: string | null;
    status?: string | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    nextToken?: string | null;
  };
}

function* getAdminIssues(): SagaIterator {
  try {
    const response = yield call(apiInstance, `/admin/issues/active`);
    yield put(fetchAdminIssuesSuccess(response.data));
  } catch (e) {
    yield put(fetchAdminIssuesError());
  }
}
function* getAdminIssuesArchived(): SagaIterator {
  try {
    const response = yield call(apiInstance, `/admin/issues/archived`);
    yield put(fetchAdminIssuesArchivedSuccess(response.data));
  } catch (e) {
    yield put(fetchAdminIssuesError());
  }
}

interface PayloadArchiveProps {
  issueId: string;
}

function* putAdminIssuesArchive({ payload: { issueId } }: PayloadAction<PayloadArchiveProps>): SagaIterator {
  try {
    const response = yield call(apiInstance.put, `/admin/issues/archive`, issueId);
    if (response.status === 200) {
      yield put(fetchAdminIssuesArchived());
      yield put(fetchAdminIssues());
    }
  } catch (e) {
    yield put(fetchAdminIssuesError());
  }
}

function* getAdminIssuesSearch({ payload: { params } }: PayloadAction<PayloadProps>): SagaIterator {
  try {
    const response = yield call(apiInstance, `/admin/issues/active`, {
      params: params ?? {},
    });
    yield put(fetchAdminIssuesSuccess(response.data));
  } catch (e) {
    yield put(fetchAdminIssuesError());
  }
}

interface PutIssuesPayloadProps {
  siteId: string;
  issueId: string;
  data: {
    status: string;
  };
}

function* putAdminIssuesStatusSaga({ payload }: PayloadAction<PutIssuesPayloadProps>): SagaIterator {
  try {
    yield call(apiInstance.put, `sites/${payload.siteId}/issues/${payload.issueId}`, payload.data);
    yield put(fetchMyReports());
    yield put(fetchAdminIssues());
  } catch (e) {
    yield put(fetchAdminIssuesError());
  }
}
function* adminIssuesSaga(): Generator<StrictEffect, void> {
  yield takeLatest(fetchAdminIssues.type, getAdminIssues);
  yield takeLatest(fetchAdminIssuesArchived.type, getAdminIssuesArchived);
  yield takeLatest(fetchAdminIssuesSearch.type, getAdminIssuesSearch);
  yield takeLatest(putAdminIssuesStatus.type, putAdminIssuesStatusSaga);
  yield takeLatest(putAdminIssuesArchiveSaga.type, putAdminIssuesArchive);
}

export { adminIssuesSaga };
